module.exports = __webpack_public_path__ + "img/ezsoft-logo-color.ed444580.png";